
export default {
  props: {
    item: { type: Object, default: null },
    title: { type: String, default: null },
  },

  computed: {
    pic() {
      if (!this.item) return null
      return this.item.packshot && this.item.packshot.origin ? this.item.packshot : null
    },
  }
}
